// Login attempts types
export const FETCH_LOGIN_ATTEMPTS = 'fetch_login_attempts';
export const FETCH_LOGIN_ATTEMPTS_SUCCESS = 'fetch_login_attempts_success';
export const FETCH_LOGIN_ATTEMPTS_ERROR = 'fetch_login_attempts_error';

// Blocked list types
export const FETCH_BLOCKED_LIST = 'fetch_blocked_list';
export const FETCH_BLOCKED_LIST_SUCCESS = 'fetch_blocked_list_success';
export const FETCH_BLOCKED_LIST_ERROR = 'fetch_blocked_list_error';

// Login stats types
export const FETCH_LOGIN_STATS = 'fetch_login_stats';
export const FETCH_LOGIN_STATS_SUCCESS = 'fetch_login_stats_success';
export const FETCH_LOGIN_STATS_ERROR = 'fetch_login_stats_error';

// Unblock IP types
export const UNBLOCK_IP = 'unblock_ip';
export const UNBLOCK_IP_SUCCESS = 'unblock_ip_success';
export const UNBLOCK_IP_ERROR = 'unblock_ip_error';

// Unblock email types
export const UNBLOCK_EMAIL = 'unblock_email';
export const UNBLOCK_EMAIL_SUCCESS = 'unblock_email_success';
export const UNBLOCK_EMAIL_ERROR = 'unblock_email_error';

// Filter types
export const SET_FILTER = 'set_filter';